enum NavigationStatus {
  success = 'success',
  warning = 'warning',
  information = 'info',
}

export {NavigationStatus};
